import React from 'react';
import useGeoLocation from '../Login/getLocation';

const LocationDisplay = () => {
  const location = useGeoLocation();
console.log(location);

  if (!location.loaded) return <p>Loading location...</p>;
  if (location.error) return <p style={{ color: 'red' }}>{location.error}</p>;

  return (
    <p>
      Your Location: {location.coordinates.latitude}, {location.coordinates.longitude}
    </p>
  );
};

export default LocationDisplay;
